import { defineAsyncComponent } from 'vue';

const cRERepListPopup = defineAsyncComponent(() => import('@/views/summary/cRERepList/cRERepListPopup.vue'));
const CRERepListAddReport = defineAsyncComponent(() => import('@/views/summary/cRERepList/CRERepListAddReport.vue'));
const CheckDataReport = defineAsyncComponent(() => import('@/views/summary/cRERepList/CheckDataReport.vue'));
const cRERepListDetail = defineAsyncComponent(() => import('@/views/summary/cRERepList/cRERepListDetail.vue'));
const ResultDataReport = defineAsyncComponent(() => import('@/views/summary/cRERepList/ResultDataReport.vue'));

const CRERepExportListPopup = defineAsyncComponent(() =>
  import('@/views/summary/cRERepExportList/CRERepExportListPopup.vue')
);

const CRERepExportListDetail = defineAsyncComponent(() =>
  import('@/views/summary/cRERepExportList/CRERepExportListDetail.vue')
);

const CRERepSettlementPopup = defineAsyncComponent(() =>
  import('@/views/summary/cRERepSettlement/CRERepSettlementPopup.vue')
);

const CRERepSettlementB02Detail = defineAsyncComponent(() =>
  import('@/views/summary/cRERepSettlement/CRERepSettlementB02Detail.vue')
);

const CRERepSettlementB03Detail = defineAsyncComponent(() =>
  import('@/views/summary/cRERepSettlement/CRERepSettlementB03Detail.vue')
);

const CRERepSettlementAddReport = defineAsyncComponent(() =>
  import('@/views/summary/cRERepSettlement/CRERepSettlementAddReport.vue')
);

const CRERepSettlementDetail = defineAsyncComponent(() =>
  import('@/views/summary/cRERepSettlement/CRERepSettlementDetail.vue')
);

const CRERepExportListTaxPopup = defineAsyncComponent(() =>
  import('@/views/summary/cRERepExportListTax/CRERepExportListTaxPopup.vue')
);

const CREREPForSuperiorsPopup = defineAsyncComponent(() =>
  import('@/views/summary/cRERepForSuperiorsTab/CREREPForSuperiorsPopup.vue')
);

const CustomRowForCrere = defineAsyncComponent(() =>
  import('@/views/summary/cRERepForSuperiorsTab/CustomRowForCrere.vue')
);

const CRERepExportListTaxResult = defineAsyncComponent(() =>
  import('@/views/summary/cRERepExportListTax/CRERepExportListTaxResult.vue')
);

const CRERepExportXMLPopUp = defineAsyncComponent(() =>
  import('@/views/summary/cRERepExportXML/CRERepExportXMLPopUp.vue')
);

const CRERepExportListTaxDetail = defineAsyncComponent(() =>
  import('@/views/summary/cRERepExportListTax/CRERepExportListTaxDetail.vue')
);

const CRERepExportListResult = defineAsyncComponent(() =>
  import('@/views/summary/cRERepExportList/CRERepExportListResult.vue')
);

const CREImportFromTKTPopup = defineAsyncComponent(() =>
  import('@/views/summary/cRERepList/CREImportFromTKTPopup.vue')
);

const SendBudgetFeesPopUp = defineAsyncComponent(() => import('@/views/summary/ConnectBumas/SendBudgetFeesPopUp.vue'));
const SendActivePopUp = defineAsyncComponent(() => import('@/views/summary/ConnectBumas/SendActivePopUp.vue'));
const SendProjectPopUp = defineAsyncComponent(() => import('@/views/summary/ConnectBumas/SendProjectPopUp.vue'));
const SendMissionPopUp = defineAsyncComponent(() => import('@/views/summary/ConnectBumas/SendMissionPopUp.vue'));
const cRERepReportSubmit = defineAsyncComponent(() =>
  import('@/views/summary/cRERepReportSubmitList/cRERepReportSubmit.vue')
);
const CompanyRepresenters = defineAsyncComponent(() =>
  import('@/views/summary/cRERepForSuperiorsTab/CompanyRepresenters.vue')
);

const cREReportSendErrorDetail = defineAsyncComponent(() =>
  import('@/views/summary/cREReportSend/cREReportSendErrorDetail.vue')
);
export function registerCRE(app) {
  app.component('cRERepListPopup', cRERepListPopup);
  app.component('CRERepListAddReport', CRERepListAddReport);
  app.component('CheckDataReport', CheckDataReport);
  app.component('ResultDataReport', ResultDataReport);
  app.component('cRERepListDetail', cRERepListDetail);
  app.component('CRERepExportListPopup', CRERepExportListPopup);
  app.component('CRERepExportListDetail', CRERepExportListDetail);
  app.component('CRERepSettlementPopup', CRERepSettlementPopup);
  app.component('CRERepSettlementB02Detail', CRERepSettlementB02Detail);
  app.component('CRERepSettlementB03Detail', CRERepSettlementB03Detail);
  app.component('CRERepExportListTaxPopup', CRERepExportListTaxPopup);
  app.component('CREREPForSuperiorsPopup', CREREPForSuperiorsPopup);
  app.component('CustomRowForCrere', CustomRowForCrere);
  app.component('CRERepExportListTaxResult', CRERepExportListTaxResult);
  app.component('CRERepExportListTaxDetail', CRERepExportListTaxDetail);
  app.component('CRERepExportListResult', CRERepExportListResult);
  app.component('CRERepSettlementDetail', CRERepSettlementDetail);
  app.component('CRERepSettlementAddReport', CRERepSettlementAddReport);
  app.component('CREImportFromTKTPopup', CREImportFromTKTPopup);
  app.component('CRERepExportXMLPopUp', CRERepExportXMLPopUp);
  app.component('SendBudgetFeesPopUp', SendBudgetFeesPopUp);
  app.component('SendMissionPopUp', SendMissionPopUp);
  app.component('SendActivePopUp', SendActivePopUp);
  app.component('SendProjectPopUp', SendProjectPopUp);
  app.component('cRERepReportSubmit', cRERepReportSubmit);
  app.component('CompanyRepresenters', CompanyRepresenters);
  app.component('cREReportSendErrorDetail', cREReportSendErrorDetail);
}
